import React from 'react';

const Customization = () => {
    // Always return null to ensure the component doesn't render
    return null;
};

export default Customization;
